import CardSystem from '../../Card/CardSystem';
import { UIEvent } from 'System/UI/BaseUISystem';
import { PlayAnimation, StartAnimationClip } from 'System/Animation/AnimationHelper';
import AnimationClip from 'System/Animation/AnimationClip';
import BaseCard from 'Prototype/Level/Card/BaseCard';
import { RenderSystemEvent } from 'System/Render/RenderSystem';
import CardComponent from 'Component/Level/Card';
import DragonbonesComponent from 'Component/Dragonbones';
import TransformComponent from 'Component/Transform';
import Point from 'Utility/Point';
import { DragonbonesFadeIn } from './DragonbonesFadeIn';
import { MainAnim } from './MainAnim';
import { Easing, Interpolation } from '@tweenjs/tween.js';
import { CARD_OFFSET_IN_STACK, CARD_STACK_OFFSET, MAX_OPENED_CARDS_IN_STACK } from 'Constants/InGame';
import { PlaySound } from 'System/Audio/AudioHelper';
import { delay } from 'Utility/Task/TaskQueue';
import Renderable from 'Component/Renderable';

interface IReceivePlinkoCardMeta {
    system: CardSystem;
}

export class ReceivePlinkoCard extends AnimationClip<IReceivePlinkoCardMeta> {
    public *execute(card: BaseCard, meta: IReceivePlinkoCardMeta): IterableIterator<number> {
        const cardComponent = card.getComponent(CardComponent);
        cardComponent.animating = true;

        const cardDBs = card.getComponentsInChildren(DragonbonesComponent);
        const cardArmature = cardDBs?.find(db => db.armatureName === 'card').gameObject;
        const checkArmature = cardDBs?.find(db => db.armatureName === 'check').gameObject;
        const effectArmature = cardDBs?.find(db => db.armatureName === 'card_revealed_effect').gameObject;

        const plinkoParent = card.parent;

        const system = meta.system;

        const animatorTransform = system.animator.getComponent(TransformComponent);
        const center = new Point(animatorTransform.width / 2, animatorTransform.height / 2);

        system.scene.emit(RenderSystemEvent.BRING_TO_FRONT, system.animator);
        system.animator.addChild(card);

        PlaySound('plinko-card-collect');

        yield* PlayAnimation(
            new DragonbonesFadeIn(effectArmature, {
                playTimes: 1,
                animationName: 'animation',
                fadeInTime: 50,
                concat: false,
            })
        );

        yield* PlayAnimation(
            new MainAnim(
                card,
                {
                    x: center.x,
                    y: center.y,
                    scaleX: 1.2,
                    scaleY: 1.2,
                    duration: 400,
                    rotation: 0,
                    easing: Easing.Sinusoidal.Out,
                    interpolation: Interpolation.Bezier,
                },
                true
            )
        );

        cardArmature.getComponent(Renderable).visible = true;

        yield* PlayAnimation(
            new DragonbonesFadeIn(cardArmature, {
                playTimes: 1,
                animationName: 'revealed',
                fadeInTime: 50,
                concat: false,
            })
        );

        system.stackContainer.addChild(card);

        yield* PlayAnimation(
            new MainAnim(
                card,
                {
                    x: CARD_STACK_OFFSET * 2 + CARD_OFFSET_IN_STACK * MAX_OPENED_CARDS_IN_STACK + 25,
                    y: 0,
                    scaleX: 0.8,
                    scaleY: 0.8,
                    duration: 400,
                    rotation: 0,
                    easing: Easing.Sinusoidal.Out,
                    interpolation: Interpolation.Bezier,
                },
                true
            )
        );

        plinkoParent.addChild(card);

        yield* PlayAnimation(
            new DragonbonesFadeIn(checkArmature, {
                playTimes: 1,
                animationName: 'animation',
                fadeInTime: 50,
                concat: false,
            })
        );

        cardComponent.animating = false;
    }
}
